import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CanActivate, Router }    from '@angular/router';

import { Observable } from 'rxjs';
import { Subject }    from 'rxjs';
import { BehaviorSubject }    from 'rxjs';

import { environment } from '../../environments/environment';

import * as hotel from '../classes/hotel';
import { HotelService } from '../hotel/hotel.service'

/**
 * This is a singleton class
 */
@Injectable()
export class LoginService implements CanActivate {

    public user:any=null
    public hotel:hotel.Hotel=null
    public isLogged:boolean=false
    public isAdmin:boolean=false
    private isLoggedSource = new BehaviorSubject<boolean>(false)
    public isLogged$ = this.isLoggedSource.asObservable()
    
    constructor( private router: Router, private http: HttpClient ) {
        console.log("In LoginService constructor ")
        if ( localStorage.getItem( 'token' ) == 'undefined' ) { // In case token is corrupted (null)
            localStorage.removeItem( 'token' )
        }
        this.checklogged()  // Update login properties on page reload
    }

    public login( email: string, password: string, cb ) {
        console.log( "Login service called" )
        this.makeLoginPost( email, password, (data:loginresponse)=> {
            if ( data ) {	// Success!
                try {
                    if ( data.token ) { // Login is OK
                        localStorage.setItem( 'token', data.token );
                        console.log( "Login OK" );
                        cb(null, "Login OK")
                    } else {    // No token => invalid password
                        console.log( "invalid password" );
                        cb( "invalid password", email );
                    }
                    this.checklogged()  // Update login properties
                }
                catch ( e ) {
                    console.error( "Exception raised : parsing error!!", e );
                }
            }
        });
    }
    
    private makeLoginPost( email: string, password: string, cb: Function ): void {
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type':  'application/json' }) };
        
        let data= this.http.post(
                environment.apiLogin,
                JSON.stringify( {
                    func: 'LOGIN',
                    email: email,
                    password: password
                }), httpOptions)
                 .subscribe(( res: loginresponse ) => {
                cb(res);
            });
    }    
   
    private renew() {
        // console.log( "renew service called" )
        let token:any=this.getToken()
        if (token==null) return
        this.makeRenewPost( token, (data)=> {
            if (data) {   // Success!
                try {
                    // let user=JSON.parse(data);
                    if ( data.token ) {
                        localStorage.setItem( 'token', data.token );
                    } else {    // No token => invalid password
                        console.log( "invalid password" );
                    }
                    this.checklogged()  // Update login properties
                }
                catch ( e ) {
                    console.error( "Exception raised : parsing error!!", e );
                }
            }
        })
    }

    private makeRenewPost( token: string, cb: Function ): void {
        const httpOptions = { headers: new HttpHeaders( { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.getToken()}` } ) };
        this.http.post(environment.apiLogin,
            JSON.stringify( {
                func: 'RENEW',
                token: token
            }),
            httpOptions )
            .subscribe(( res: loginresponse ) => {
                cb( res );
            });
    }
    
    public logout(): any {
        localStorage.removeItem( 'token' )
        this.checklogged()  // Update login properties
    }
    
    public getToken(): any {    // Used by various services in the "bearer" http param
        if ( localStorage.getItem( 'token' ) == 'undefined' ) { // In case token is corrupted (null)
            localStorage.removeItem( 'token' )
            return null
        }
        return localStorage.getItem( 'token' );
    }

    private parseJwt( token: string ): any {
        var base64Url = token.split( '.' )[1];
        var base64 = base64Url.replace( '-', '+' ).replace( '_', '/' );
        // console.log( "  parseJwt, token:" + ( atob( base64 ) ))
        return JSON.parse( atob( base64 ) );
    }

    /**
     * Is user logged?
     * Update user, isLogged and isAdmin properties from localStorage token, return isLogged
     * Called whenever a property needs update (login, logout, renew)
     */
    private checklogged(): boolean {   // TODO horrible function w/ 3 exits and side effects 
        
        console.log( "checklogged() called (expensive one)" );
        let token = localStorage.getItem( 'token' )
        this.user = (token==null?null:this.parseJwt( token ))   // TODO test invalid token
        if (token===null) this.hotel=null                       // Flush (shared) hotel data
        
        if ( !this.user || !this.user.user) this.user=null       // user is null OR id is null (why token != null??) => not connected
        
        if ( this.user == null ) {
            console.log( "  checklogged() test. No Token" )
            this.isLogged=false
            this.isAdmin=false
            this.isLoggedSource.next(this.isLogged)
            return false // No token 
        }
        let exp: Date = new Date( this.user.exp )

        if ( exp.getTime() > Date.now() ) {   // Token not yet expired, OK 
            console.log( "  checklogged() test. Token Valid until " + exp )
            this.isLogged=true
            this.isAdmin=(this.user.level===0)
            this.isLoggedSource.next(this.isLogged)
            console.log( "  User info:" + JSON.stringify(this.user) );
            return true
        } else {    // Expired token
            console.log( "  checklogged() test. Expired Token" )
            this.isLogged=false
            this.isAdmin=false
            this.isLoggedSource.next(this.isLogged)
            return false
        }
    }

    /** Needed by CanActivate interface, is route accessible? ie is user logged? **/
    public canActivate() {
        console.log( 'AuthGuard#canActivate called (expensive)' );

        if (this.checklogged()) {    // Valid token, OK and renew
            this.renew()
            return true
        } else {    // Invalid or expired => force login
            // console.log( "Invalid token" )
            this.router.navigate( ['/home'] )
            return false
        }
    }
}

export interface loginresponse {
    error: string;
    token: string;
  }
